import { LPBondsNftsApi } from 'clientSDK';

const api = new LPBondsNftsApi();

export default {
  getNftsFromAddress: async ({
    address,
    skip = 0,
    limit = 100,
    buyNow = 0,
    tokenIds,
    traits,
    min,
    max,
  }) =>
    await api.getNftsFromAddress({
      address,
      skip,
      limit,
      buyNow,
      tokenIds,
      traits,
      min,
      max,
    }),

  getNftTokenFromId: async ({ contractAddress, tokenId }) =>
    await api.getNftTokenFromId({ contractAddress, tokenId }),

  getNftsByOwnerInCollection: async ({ owner, collection, skip = 0, limit = 50 }) =>
    await api.getNftsByOwnerInCollection({ owner, contractAddress: collection, skip, limit }),

  refreshMetadata: async ({ contractAddress, tokenId }) =>
    await api.refreshMetadata({ contractAddress, tokenId }),

  getNfts: async ({ skip, limit, buyNow, owner }) => await api.list({ skip, limit, buyNow, owner }),

  getAssetTradingHistory: async ({
    contractAddress,
    tokenId,
    listing = true,
    mint = true,
    sale = true,
    offer = true,
    bid = true,
    burn = true,
    transfer = true,
    skip = 0,
    limit = 50,
  }) =>
    await api.getTradingHistory({
      contractAddress,
      tokenId,
      listing,
      mint,
      sale,
      offer,
      bid,
      burn,
      transfer,
      skip,
      limit,
    }),

  getAssetOffers: async ({ contractAddress, tokenId, skip = 0, limit = 50, direction = 'desc' }) =>
    await api.getAssetOffers({ contractAddress, tokenId, skip, limit, direction }),

  getNftBids: async ({ contractAddresses, ownerAddress, limit, exclude }) =>
    await api.getNftBids({ contractAddresses, ownerAddress, limit, exclude }),
};
